// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"248d76f2cdbefab882af","532":"fa6813e6c684ad096dfc","691":"053bef48aeab92ecba06"}[chunkId] + ".js";
};